import React, { useState } from 'react';
import isNil from 'lodash/isNil';
import ConnectAsContext from 'contexts/connect_as/context';
import { switchUser } from 'requests/switch_user';
import {
  getAdminAuthorizationToken,
  setAdminAuthorizationToken,
  setAuthorizationToken,
  deleteAdminAuthorizationToken,
} from 'services/authorization_token';
import { deleteActiveGroupCookie } from 'contexts/active_group/provider';

const ConnectAsProvider = ({ children }) => {
  const cookieAdminAuthorizationToken = getAdminAuthorizationToken();
  const [isConnectedAs, setIsConnectedAs] = useState(
    !isNil(cookieAdminAuthorizationToken),
  );
  const [session, setSession] = useState(null);

  const connectAs = (userId) => {
    switchUser(userId).then((response) => {
      const adminAuthorizationToken = response.data.admin_authorization_token;
      setAdminAuthorizationToken(adminAuthorizationToken);
      setAuthorizationToken(response.headers.authorization.split(' ')[1]);
      window.location = window.location.pathname;
    });
  };

  const terminateSession = () => {
    deleteActiveGroupCookie();
    setAuthorizationToken(getAdminAuthorizationToken());
    setTimeout(() => {
      deleteAdminAuthorizationToken();
      window.location = window.location.pathname;
    }, 300);
  };

  return (
    <ConnectAsContext.Provider
      value={{
        isConnectedAs,
        session,
        connectAs,
        terminateSession,
      }}
    >
      {children}
    </ConnectAsContext.Provider>
  );
};

export default ConnectAsProvider;
